/**
* @ngdoc service
* @name  sharebase-app.sbaSearchDataStore
* 
* @description 
* A datastore used to interact with the results of a content search.
* 
**/
export function SearchDataStoreFactory(
	$q:ng.IQService, 
	sbSearchService
) {
	var _allContent = [];
	
	return {
		/**
		* @ngdoc method
		* @name sbaSearchDataStore#load
		* @methodOf sharebase-app.sbaSearchDataStore
		* @kind function
		*
		* @description
		* Loads search results for the given phrase
		* 
		* @param {string} searchPhrase Term to search content against
		*
		* @returns {Deferred} A promise that will resolve with an
		* array of matching content
		*/
		load,
		
		/**
		* @ngdoc property
		* @name sbaSearchDataStore#results
		* @propertyOf sharebase-app.sbaSearchDataStore
		* @kind property
		*
		* @description
		* The current search results
		*
		* @returns {array} An array of search results
		*/
		get results() { return _allContent; },
	};

	function load(searchPhrase) {
		return sbSearchService
				.getResults(searchPhrase, 100)
				.then(function (response) {
					_allContent = response.results;
					return response.results;
				});
	}
}

SearchDataStoreFactory.$inject = [
	'$q',
	'sbSearchService'
];



// WEBPACK FOOTER //
// ./src/sharebase-app/dataStores/searchDataStore.ts